import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'

import Index from '@/views/Index.vue'
import Admin from '@/views/Admin.vue'
import Home from '@/views/Home.vue'
import Profile from '@/views/Profile.vue'
import Registration from '@/views/Registration.vue'
import AddRegistration from '@/views/AddRegistration.vue'
import EditRegistration from '@/views/EditRegistration.vue'
import ViewRegistration from '@/views/ViewRegistration.vue'
import Login from '@/views/Login'
import Signup from '@/views/Signup'
import ForgotPassword from '@/views/ForgotPassword'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/admin/:id',
    name: 'Admin',
    component: Admin,
    meta: {
      requiresAuth:true,
    }
  },
  {
    path: 'admin/registration/:orderId',
    name: 'EditRegistration',
    component: EditRegistration,
    meta: {
      requiresAuth:true,
    }
  },
  {
    path: '/registrations/view/:orderId',
    name: 'ViewRegistration',
    component: ViewRegistration,
    meta: {
      requiresAuth:true,
    }
  },
  {
    path: '/registrations',
    name: 'Registration',
    component: Registration,
    meta: {
      requiresAuth:true,
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth:true,
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth:false,
    }
  },
  {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresAuth:false,
      }
  },
  {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        requiresAuth:false,
      }
  },
  /* {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about"  '../views/About.vue')
  }, */
  {
    path: '/:id/registrations/add',
    name: 'AddRegistration',
    component: AddRegistration,
    meta: {
      requiresAuth:true,
    }
  },
  {
    path: '/:id',
    name: 'Home',
    component: Home
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
      next('/login?from='+to.path)
  } else if (requiresAuth && currentUser) {
      next()
  } else {
      next()
  }
})

export default router
